import { render, staticRenderFns } from "./SimpleCastFeedForm.vue?vue&type=template&id=63739be1"
import script from "./SimpleCastFeedForm.vue?vue&type=script&lang=js"
export * from "./SimpleCastFeedForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports